import React from 'react';
import {
  useTable,
  useSortBy,
  usePagination,
  useFilters,
  useGroupBy,
  useExpanded,
} from 'react-table';
import PropTypes from 'prop-types';
import { Table as BootstrapTable } from 'react-bootstrap';
import Pagination from './Pagination';
import DefaultColumnFilter from './Filter/DefaultColumnFilter';

export default function Table({
  data, columns, initialState, onFilterChange, filterTypes, ...props
}) {
  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    [],
  );

  console.log('columns', columns);
  console.log('data', data);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    rows,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      autoResetPage: false,
      autoResetSortBy: false,
      autoResetGroupBy: false,
      autoResetExpanded: false,
      autoResetFilters: false,
      initialState,
      defaultColumn,
      filterTypes,
    },
    useFilters,
    useGroupBy,
    useSortBy,
    useExpanded,
    usePagination,
  );

  React.useEffect(() => {
    gotoPage(0);
    if (onFilterChange) {
      onFilterChange(rows.length);
    }
  }, [rows, gotoPage]);

  // Render the UI for your table
  return (
    <>
      <BootstrapTable
        {...props}
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th key={`th-${column.id}`} className={`bottom ${column.isSorted ? 'sorted' : ''} typography-default-text-title`} style={{ verticalAlign: 'top', width: `${column.fixedWidth}px` }}>
                  <div {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    {/* eslint-disable-next-line no-nested-ternary */}
                    {column.isSorted ? (column.isSortedDesc
                      ? <i className="ic-arrow-down" />
                      : <i className="ic-arrow-up" />) : ''}
                  </div>
                </th>
              ))}
            </tr>
          ))}
          {headerGroups.map((headerGroup) => {
            const headerGroupProps = headerGroup.getHeaderGroupProps();
            return (
              <tr key={`${headerGroupProps.key}-filter`}>
                {headerGroup.headers.map(column => (
                  <th key={`th-${column.id}`} className="th-filter" style={{ verticalAlign: 'top', width: `${column.fixedWidth}px` }}>
                    {column.canFilter && (
                      <>{column.render('Filter')}</>
                    )}
                  </th>
                ))}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td className={`td-${cell.column.id}`} {...cell.getCellProps()}>
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </BootstrapTable>
      <Pagination
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageOptions={pageOptions}
        nextPage={nextPage}
        setPageSize={setPageSize}
        pageIndex={pageIndex}
        gotoPage={gotoPage}
        canPreviousPage={canPreviousPage}
        pageSize={pageSize}
        pageCount={pageCount}
      />
    </>
  );
}

Table.defaultProps = {
  initialState: { pageIndex: 0, pageSize: 25 },
  onFilterChange: undefined,
  filterTypes: undefined,
    data: []
};

Table.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array.isRequired,
  initialState: PropTypes.object,
  onFilterChange: PropTypes.func,
  filterTypes: PropTypes.object,
};
